
import React from 'react'
import {
  RuleID,
  IsDimensionContext,
  FinalDocu,
  Publishopen,
  PublishForEntity,
  AlertContext,
  DialogContext,
  BackdropContext,
  DrawerContext,
  EntityRelationShipContext,
  EntityGroupRelationShipContext,
  DrawLineContext,
  EntityLeftContext,
  ResouceTemplates,
  CustomTemplate,
  SelectedTemplate,
  RightSideNav,
  MasterTemplates, ConfirmationContext, PropertiesContext, CollapseForEntity, RenameManagement
} from '../contexts'
import { DataJson } from '../contexts/enterprise/contextdata'

const withAllContexts = Component => props => {
  const ruleID = React.useContext(RuleID)
  const isDimensionContext = React.useContext(IsDimensionContext)
  const finalDocu = React.useContext(FinalDocu)
  const publishopen = React.useContext(Publishopen)
  const publishForEntity = React.useContext(PublishForEntity)
  const alert = React.useContext(AlertContext)
  const dialog = React.useContext(DialogContext)
  const backDrop = React.useContext(BackdropContext)
  const drawer = React.useContext(DrawerContext)
  const relationshipcontext = React.useContext(EntityRelationShipContext)
  const grouprelationshipcontext = React.useContext(EntityGroupRelationShipContext)
  const drawLine = React.useContext(DrawLineContext)
  const leftContext = React.useContext(EntityLeftContext)
  const datajson = React.useContext(DataJson)
  const resouceTemplates = React.useContext(ResouceTemplates)
  const customTemplate = React.useContext(CustomTemplate)
  const selectedTemplate = React.useContext(SelectedTemplate)
  const rightNav = React.useContext(RightSideNav)
  const masterDatas = React.useContext(MasterTemplates)
  const confirmationContext = React.useContext(ConfirmationContext)
  const propertiesContext = React.useContext(PropertiesContext)
  const collapseForEntity = React.useContext(CollapseForEntity);
  const renameContext = React.useContext(RenameManagement);
  return (
    <Component
      {...props}
      ruleID={ruleID}
      isDimensionContext={isDimensionContext}
      finalDocu={finalDocu}
      publishopen={publishopen}
      publishForEntity={publishForEntity}
      datajson={datajson}
      leftContext={leftContext}
      drawLine={drawLine}
      resouceTemplates={resouceTemplates}
      customTemplate={customTemplate}
      relationshipcontext={relationshipcontext}
      grouprelationshipcontext={grouprelationshipcontext}
      selectedTemplate={selectedTemplate}
      confirmationContext={confirmationContext}
      rightNav={rightNav}
      alert={alert}
      masterDatas={masterDatas}
      dialog={dialog}
      backDrop={backDrop}
      drawer={drawer}
      queryParams={{}}
      properties={propertiesContext}
      collapseForEntity={collapseForEntity}
      renameContext={renameContext}
    >
      {props.children}
    </Component>
  )
}

export default withAllContexts